//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BtnToggle from '../../../../components/btnToggle/index.js';

export default {
  extends: BtnToggle,
};
